<template>
  <div class="box">
      <div class="box-item" v-for="item in projectList" :key="item.id">
          <div class="item-img" style="cursor: pointer;" @click="handleClick(item.id)">
              <img v-if="item.periodicalLogo" v-lazy="$global.imgUrl + item.periodicalLogo" alt=""/>
              <img
                v-else
                :src="require('@/assets/img/details/qikan.png')"
                alt=""
              />
          </div>
          <div class="item-content">
            <p class="name-box" style="cursor: pointer;" @click="handleClick(item.id)">{{item.name}}</p>
            <div class="content-unit" v-if="item.organizerList && item.organizerList.length > 0">
                <span>主办单位：</span>
                <span
                    style="margin-right: 5px;"
                    v-for="i in item.organizerList"
                    :key="i.orgId">
                    {{i.orgName}}
                </span>
            </div>
            <div class="content-unit" v-else>
                <span>主办单位：</span>
                <span style="margin-right: 5px;">{{item.responsibleDept}}</span>
            </div>
            <div class="content-unit">
                <span>出版周期：</span>
                <span style="margin-right: 5px;">{{ item.publishPeriod | period }}</span>
            </div>
            <div class="content-unit">
                <span>CN：</span>
                <span style="margin-right: 10px;">{{ item.cn }}</span>
                <span>ISSN：</span>
                <span>{{ item.issn }}</span>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  props: {
    projectList: {
      type: Array,
      default: () => [],
    },
  },
  filters: {
    period(num) {
      if (num == 1) {
        return `年刊`;
      } else if (num == 2) {
        return `半年刊`;
      } else if (num == 3) {
        return `季刊`;
      } else if (num == 4) {
        return `双月刊`;
      } else if (num == 5) {
        return `月刊`;
      } else if (num == 6) {
        return `半月刊`;
      } else if (num == 7) {
        return `旬刊`;
      } else if (num == 8) {
        return `周刊`;
      } else if (num == 9) {
        return `周二刊`;
      } else {
        return '';
      }
      // 1 年刊 2半年刊 3 季刊 4 双月刊 5 月刊 6 半月刊 7 旬刊 8 周刊 9 周二刊
    },
  },
  methods: {
    handleClick(id) {
      let routeUrl = this.$router.resolve({
        path: "/bkzxdetail",
        query: { title: this.$route.query.title, id },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
    display: flex;
    flex-wrap: wrap;
    .box-item {
        display: flex;
        padding: 0px 50px 55px;
        width: 450px;
        &:nth-child(2n-1) {
            padding-right: 49px;
            border-right: 1px dotted #DCDCDC; ;
        }
        .item-img {
            width: 64px;
            margin-right: 11px;
            img {
                width: 64px;
                height: 64px;
                border-radius: 32px;
            }
        }
        .item-content {
            width: 275px;
            .name-box {
                margin-bottom: 10px;
                font-size: 18px;
                font-weight: 600;
                color: #263D78;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .content-unit {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                line-height: 30px;
                font-size: 14px;
                color: #333;
            }
        }
    }
}
</style>
